import React, { useState } from "react";
import { Button, Descriptions, Input, Space, Tag, message } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Locale } from "../../utils";
import { getUserInfo } from "../../utils/redux/reducers/User";
import ApiManager from "../../utils/api/ApiManager";

const i18n = Locale.getInstance();
const api = ApiManager.getInstance().groupon;

function OrderDetail() {
  const user = useSelector((state) => getUserInfo(state));
  const history = useHistory();
  const { id } = useParams();
  const location = useLocation();
  const [order, setOrder] = useState(location.state?.order);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    if (!user.token) return;
    const res = await api.orderShow.run({ token: user.token, path: { id } });
    if (res.result) setOrder(res.data);
  };

  React.useEffect(() => {
    if (!order) load();
  }, []);

  const onVerify = async () => {
    setLoading(true);
    try {
      const res = await api.verify.run({
        token: user.token,
        data: { redeem_token: token },
      });
      if (res.result) {
        message.success(res.message || i18n.t("groupon.verified"));
        load();
      } else {
        message.warning(res.message);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const onRefund = async () => {
    setLoading(true);
    try {
      const res = await api.orderRefund.run({ token: user.token, path: { id } });
      if (res.result) {
        message.success(res.message || i18n.t("groupon.refunded"));
        load();
      } else {
        message.warning(res.message);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  if (!order) return null;

  const snapshot = order.product_snapshot || {};

  return (
    <div style={{ padding: 24 }}>
      <Button type="text" icon={<LeftOutlined />} onClick={() => history.goBack()}>
        {i18n.t("groupon.back")}
      </Button>
      <Descriptions bordered column={1} style={{ marginTop: 16 }}>
        <Descriptions.Item label={i18n.t("order.orderNo")}>{order.order_no}</Descriptions.Item>
        <Descriptions.Item label={i18n.t("groupon.deal")}>
          {i18n.getPropNameByLocale(snapshot)}
        </Descriptions.Item>
        <Descriptions.Item label={i18n.t("order.status")}>
          <Tag>{i18n.t(`groupon.statusLabel.${order.status}`)}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label={i18n.t("groupon.cash")}>
          ¥{(order.cash_amount / 100).toFixed(2)}
        </Descriptions.Item>
        <Descriptions.Item label={i18n.t("groupon.points")}>
          {order.points_used}
        </Descriptions.Item>
        <Descriptions.Item label={i18n.t("groupon.expiresAt")}>
          {order.expires_at || "-"}
        </Descriptions.Item>
        <Descriptions.Item label={i18n.t("groupon.redeemToken")}>
          {order.redeem_token || "-"}
        </Descriptions.Item>
      </Descriptions>
      {order.status === 1 && (
        <Space style={{ marginTop: 24 }}>
          <Input
            placeholder={i18n.t("groupon.enterToken")}
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
          <Button type="primary" loading={loading} onClick={onVerify}>
            {i18n.t("groupon.verify")}
          </Button>
        </Space>
      )}
      {order.status === 2 && (
        <Button danger style={{ marginTop: 24 }} loading={loading} onClick={onRefund}>
          {i18n.t("groupon.refund")}
        </Button>
      )}
    </div>
  );
}

export default OrderDetail;
